<template>
  <b-button
    v-if="showBackBtn"
    @click="clickBackBtn"
    class="gid-back-btn"
    variant="primary"
  >
    <i class="material-icons">arrow_back</i>
  </b-button>
</template>

<script>
export default {
  computed: {
    showBackBtn() {
      return window.navigator.standalone == true;
    },
  },
  methods: {
    clickBackBtn() {
      window.history.back();
    },
  },
};
</script>

<style lang="scss">
.gid-back-btn {
  &.btn {
    display: flex;
    padding: 0.4rem 0.5rem;
    font-size: 1.25rem;
    border-color: rgba($color: #fff, $alpha: 0.1);
  }
}
</style>
